import React from 'react';
import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import PropTypes from 'prop-types';

const CustomizablePopover = ({
  anchorEl,
  id,
  popoverMainContent,
  popoverHeaderContent,
  handlePopoverClose,
  openPopover,
  popoverFooterContent,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <Popover
      anchorEl={anchorEl}
      anchorOrigin={{
        horizontal: 'center',
        vertical: 'top',
      }}
      disableAutoFocus
      disableRestoreFocus
      disableScrollLock
      hideBackdrop
      id={id}
      onClose={handlePopoverClose}
      open={openPopover}
      slotProps={{
        paper: {
          onMouseEnter,
          onMouseLeave,
          sx: {
            borderRadius: 0.5,
            mt: -1,
            pointerEvents: 'auto',
          },
        },
      }}
      sx={{
        pointerEvents: 'none',
      }}
      transformOrigin={{
        horizontal: 'center',
        vertical: 'bottom',
      }}
    >
      <Box
        sx={{
          p: 2, // parent box controls padding
        }}
      >
        <Box
          sx={{
            display: 'flex',
            p: 0,
          }}
        >
          {popoverHeaderContent}
        </Box>
        <Box sx={{ mt: 2, pb: popoverFooterContent ? 2 : 0 }}>{popoverMainContent}</Box>
        <Box>{popoverFooterContent}</Box>
      </Box>
    </Popover>
  );
};

CustomizablePopover.propTypes = {
  anchorEl: PropTypes.shape({}),
  handlePopoverClose: PropTypes.func,
  id: PropTypes.string.isRequired,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  openPopover: PropTypes.bool,
  popoverAnchor: PropTypes.shape({}),
  popoverFooterContent: PropTypes.node,
  popoverHeaderContent: PropTypes.node,
  popoverMainContent: PropTypes.node,
};

CustomizablePopover.defaultProps = {
  anchorEl: null,
  handlePopoverClose: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  openPopover: false,
  popoverAnchor: null,
  popoverFooterContent: null,
  popoverHeaderContent: null,
  popoverMainContent: null,
};

export default CustomizablePopover;
